import {
  findByCpfInBigData,
  findByPostalCodeInBigData,
} from "../repositories/integrations/bigdata";
import { getCompanyDataByBigData } from "../utils/getCompanyDataByBigData";
import MaskService from "../utils/mask/maskService";
import { notify } from "../utils/notify";

const handleDocumentInfosByBigData = async (data) => {
  switch (data.type) {
    case "cnpj":
      return handleCompanyByBigData(data.document, data.setters);
    case "cpf":
      return handlePersonByBigData(data.document, data.birthDate, data.setters);
    default:
      break;
  }
};

const handleCompanyByBigData = async (
  document,
  {
    setTelephone = () => {},
    setReason = () => {},
    setFantasy = () => {},
    setCnae = () => {},
    setNumber = () => {},
    setState = () => {},
    setAddress = () => {},
    setCity = () => {},
    setDistrict = () => {},
    setCep = () => {},
    setModalOpen = () => {},
    setEmail = () => {},
    setLoading = () => {},
  }
) => {
  try {
    setLoading((current) => ({ ...current, handleFindByCnpjHub: true }));

    const companyData = await getCompanyDataByBigData(document);

    if (companyData?.success) {
      const validPhone = MaskService.toMask(
        "cel-phone",
        (companyData.phones?.[0]?.number || "").split("/")?.[0] || ""
      );

      const maskedPostalCode = companyData?.address?.postalCode
        ? MaskService.toMask("cep", companyData?.address?.postalCode)
        : "";

      setTelephone(validPhone);
      setReason(companyData?.reason || companyData?.corporate_name || "");
      setFantasy(companyData?.fantasy || "");
      setCnae(companyData?.cnae?.code || "");
      setNumber(companyData?.address?.number || "");
      setState(companyData?.address?.state || "");
      setCep(maskedPostalCode);
      setAddress(companyData?.address?.street || "");
      setCity(companyData?.address?.city || "");
      setDistrict(companyData?.address?.district || "");
      setEmail(companyData?.email || "");

      setModalOpen(true);
      return { ...companyData, cep: maskedPostalCode, phone: validPhone };
    } else throw new Error();
  } catch (error) {
    console.error(error);
    notify(
      "Não foi possível realizar o autopreenchimento, certifique-se de que o documento é válido."
    );
  } finally {
    setLoading((current) => ({ ...current, handleFindByCnpjHub: false }));
  }
};

const handlePersonByBigData = async (
  document,
  birthDate,
  { setFantasy = () => {}, setReason = () => {} }
) => {
  try {
    const { data: callback } = await findByCpfInBigData(document, birthDate);
    if (callback?.success) {
      const {
        data: { data: personData },
      } = callback;

      setReason(personData?.name || "");
      setFantasy(personData?.name || "");

      return personData;
    } else throw new Error();
  } catch (error) {
    console.error(error);
    notify(
      "Não foi possível realizar o autopreenchimento, certifique-se de que o documento é válido."
    );
  }
};

const handleAddressInfosByBigData = async ({
  postalCode,
  setDistrict = () => {},
  setCounty = () => {},
  setAddress = () => {},
  setUf = () => {},
  setCodIbge = () => {},
}) => {
  try {
    const { data: callback } = await findByPostalCodeInBigData(postalCode);

    if (callback.success) {
      const {
        data: { data: addressData },
      } = callback;

      setAddress(addressData.street || "");
      setDistrict(addressData.neighborhood || "");
      setCounty(addressData.city || "");
      setUf(addressData.stateCode || "");
      setCodIbge(addressData.ibgeCode || "");

      return addressData;
    } else throw new Error();
  } catch (error) {
    console.error(error);
    notify(
      "Não foi possível realizar o autopreenchimento, certifique-se de que o CEP é válido."
    );
  }
};

export {
  handleDocumentInfosByBigData,
  handleCompanyByBigData,
  handleAddressInfosByBigData,
  handlePersonByBigData,
};
